import { useQuestFlags } from './useQuestFlags';

export const useVisibleButton = ({ quest }) => {
  const { isCollected, isComplete, button_link, internal_link } = quest;
  const { isSubscribeTask } = useQuestFlags({ quest });

  return !isCollected && (isComplete || isSubscribeTask || internal_link || button_link);
};
